export const WELCOME_REGISTER_KEY = 'welcomeRegister'
